
 if ($(window).width() < 750) {
         $('.footer-block--menu h2').click(function() {
             if ($(this).parent().hasClass('active')){
                  $(this).parent().find('ul').slideUp();
                 $(this).parent().removeClass('active');
             }
             else{
                $('.footer-block--menu ul').slideUp();
                 $('.footer-block--menu').removeClass('active');
                 
                 $(this).parent().addClass('active');
                $(this).parent().find('ul').slideDown();
             }
            });
      $('.footer-block--menu h2').first().click();
                    
    }

  var dimage = $('.image-link-last').html();
  // console.log(dimage);
  $('body').on('mouseover', '.mega-menu', function() {
    $(this).attr('open', true);
    $('body').addClass('mega-menu-open');  
    if ($('sticky-header').hasClass('header-wrapper')) { 
       $('sticky-header').removeClass('color-scheme-20caa082-f8ea-4409-927b-5d2d2a2c04e2');
      $('sticky-header').addClass('color-scheme-1');
  
      $('sticky-header').removeClass('header-transparent');
      $('sticky-header').addClass('active-mega');
      $('.utility-bar').removeClass('announcement-transparent');
      $('.main-header-fixed').addClass('mega-menu_active');
    }
  });
  
$('body').on('mouseout', '.mega-menu', function(){
    $(this).removeAttr('open');
    $('body').removeClass('mega-menu-open');
    
    if ($('.header-group-wrapper').hasClass('transparent-header')) {
        $('sticky-header').addClass('color-scheme-20caa082-f8ea-4409-927b-5d2d2a2c04e2');
        $('sticky-header').addClass('header-transparent');
          
       
        if ($('.section-header').hasClass("shopify-section-header-sticky")) {
            $('sticky-header').addClass('color-scheme-1');
          $('sticky-header').removeClass('color-scheme-20caa082-f8ea-4409-927b-5d2d2a2c04e2');
        } else {
            $('sticky-header').removeClass('color-scheme-1');
        }
        
        $('.main-header-fixed').removeClass('mega-menu_active');
        $('.utility-bar').addClass('announcement-transparent');
    }
});

if ($(window).width() < 750) {
  $(document).on('click', '.learn-more.open-trigger', function () {
    var headerHeight = $('.header-group-wrapper').outerHeight() || 0;
    var target = $('.description-section');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 500);
    }
  });
}
else {
  $(document).on('click', '.learn-more.open-trigger', function () {
    const section = $(this).closest('.collection-banner-section');

    section.find('.banner__text.short-description').hide();
    section.find('.banner__text.full-description').fadeIn();

    section.addClass('overlayed-text');
  });

  $(document).on('click', '.learn-more.close-trigger', function () {
    const section = $(this).closest('.collection-banner-section');

    section.find('.banner__text.full-description').hide();
    section.find('.banner__text.short-description').fadeIn();

    section.removeClass('overlayed-text');
  });
}


$('.banner__text.full-description .rte').each(function () {
  let $container = $(this);
  let $currentWrap = null;

  $container.children().each(function () {
    if ($(this).is('h2')) {
      // Start a new wrapper
      $currentWrap = $('<div class="desc-wrap"></div>');
      $(this).before($currentWrap);
    }

    if ($currentWrap) {
      $currentWrap.append(this);
    }
  });
});